import { render, staticRenderFns } from "./CompilationView.vue?vue&type=template&id=3821ba79&"
import script from "./CompilationView.vue?vue&type=script&lang=ts&"
export * from "./CompilationView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports